var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.08333V10.0833C11.25 10.4042 11.1358 10.6788 10.9073 10.9073C10.6788 11.1358 10.4042 11.25 10.0833 11.25H1.91667C1.59583 11.25 1.32118 11.1358 1.09271 10.9073C0.864236 10.6788 0.75 10.4042 0.75 10.0833V1.91667C0.75 1.59583 0.864236 1.32118 1.09271 1.09271C1.32118 0.864236 1.59583 0.75 1.91667 0.75H8.91667L11.25 3.08333ZM10.0833 3.57917L8.42083 1.91667H1.91667V10.0833H10.0833V3.57917ZM6 9.5C6.48611 9.5 6.89931 9.32986 7.23958 8.98958C7.57986 8.64931 7.75 8.23611 7.75 7.75C7.75 7.26389 7.57986 6.85069 7.23958 6.51042C6.89931 6.17014 6.48611 6 6 6C5.51389 6 5.10069 6.17014 4.76042 6.51042C4.42014 6.85069 4.25 7.26389 4.25 7.75C4.25 8.23611 4.42014 8.64931 4.76042 8.98958C5.10069 9.32986 5.51389 9.5 6 9.5ZM2.5 4.83333H7.75V2.5H2.5V4.83333Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.4545bfa9.svg";
export { ForwardRef as ReactComponent };